import { createAction } from '@reduxjs/toolkit'
import { LegalWritingStatus, LegalWritingType } from 'src/enums/EscritosLegales'

export const setLegalWritingStatusAction = createAction<LegalWritingStatus>(
  'legalWriting/SET_LEGAL_WRITING_STATUS'
)

export const setLegalWritingTypeAction = createAction<LegalWritingType>(
  'legalWriting/SET_LEGAL_WRITING_TYPE'
)

export const addFormValidatorFieldAction = createAction<any[]>(
  'legalWriting/ADD_FORM_VALIDATOR_FIELD'
)

export const removeFormValidatorFieldAction = createAction<string>(
  'legalWriting/REMOVE_FORM_VALIDATOR_FIELD'
)

export const addFormValidatorValueAction = createAction<any>(
  'legalWriting/ADD_FORM_VALIDATOR_VALUE'
)

export const removeFormValidatorValueAction = createAction<string>(
  'legalWriting/REMOVE_FORM_VALIDATOR_VALUE'
)

export const addFormValidatorErrorAction = createAction<any>(
  'legalWriting/ADD_FORM_VALIDATOR_ERROR'
)

export const removeFormValidatorErrorAction = createAction<string>(
  'legalWriting/REMOVE_FORM_VALIDATOR_ERROR'
)

export const clearFormValidatorErrorsAction = createAction<void>(
  'legalWriting/CLEAR_FORM_VALIDATOR_ERRORS'
)
